import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import usePastTime from 'hooks/usePastTime';
import { BrokerMessageType } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { getUserFullName } from 'utils';
import { NewTag } from 'router/subrouters/DataRoom/components/NewTag';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';

import './MessagesFromUploader.styles.scss';

type MessagesFromUploaderProps = {
  className?: string;
  rfiId: string;
  brokerMessages: BrokerMessageType[];
};

const MessagesFromUploader: React.FC<MessagesFromUploaderProps> = (props) => {
  const { className, rfiId, brokerMessages } = props;

  const classes = classNames('messages-from-uploader', className);

  const { t } = useTranslation();
  const pastTime = usePastTime();

  const { getIsNew } = useContext(RfiContext);

  if (!brokerMessages?.length) return null;

  return (
    <div className={classes}>
      <p>{t('messagesFromUploader')}</p>

      {brokerMessages.map(({ addedAt, content, dataRoomRFIFileUploader }) => (
        <div
          key={+new Date(addedAt)}
          className="messages-from-uploader__message white-panel"
        >
          <p>{content}</p>
          <p>
            <span>{pastTime(addedAt)}</span>
            {dataRoomRFIFileUploader?.firstName && (
              <span>
                {getUserFullName(
                  dataRoomRFIFileUploader.firstName,
                  dataRoomRFIFileUploader.lastName,
                )}
              </span>
            )}
            <NewTag variant="green" isNew={getIsNew(rfiId, addedAt)} />
          </p>
        </div>
      ))}
    </div>
  );
};

export default MessagesFromUploader;
